var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"text-5xl lg:text-6xl hover:opacity-75 text-gray-900 text-5xl",class:_vm.className})}
var staticRenderFns = []

export { render, staticRenderFns }